module.exports = __webpack_public_path__ + "img/blue1.93853bc0.png";